export const UPDATE = "update";
export const UPDATED = "updated";

export const updateAlarm = (dispatch) => {
  dispatch({
    type: UPDATE,
  });
};

export const updatedAlarm = (
  dispatch,
  onSiteServiceWorksheet,
  notApproveonSiteServiceWorksheetTask,
  servicewWorksheet,
  email,
) => {
  dispatch({
    type: UPDATED,
    onSiteServiceWorksheet,
    notApproveonSiteServiceWorksheetTask,
    servicewWorksheet,
    email,
  });
};
